/**
 * SL Quick-Add Modal
 * ──────────────────
 * Tıklanan sepet ikonundan product.handle alınır,
 * Shopify Product JSON API ile ürün verileri çekilir,
 * modal içine görsel + varyant seçiciler + fiyat doldurulur,
 * seçilen varyant sepete eklenir (AJAX).
 * SL 2026-10-05: alleen bestaande combinaties kiesbaar (zie refreshOptions).
 */
(function () {
  'use strict';

  /* ── DOM refs ── */
  var overlay  = document.getElementById('SlQuickAddOverlay');
  var closeBtn = document.getElementById('SlQaClose');
  var imgEl    = document.getElementById('SlQaImg');
  var vendorEl = document.getElementById('SlQaVendor');
  var titleEl  = document.getElementById('SlQaTitle');
  var priceEl  = document.getElementById('SlQaPrice');
  var optionsEl= document.getElementById('SlQaOptions');
  var atcBtn   = document.getElementById('SlQaAtcBtn');
  var atcLabel = atcBtn  ? atcBtn.querySelector('.sl-qa__atc-label') : null;
  var feedback = document.getElementById('SlQaFeedback');
  var viewLink = document.getElementById('SlQaViewLink');

  if (!overlay) return;

  var currentProduct  = null;
  var selectedVariant = null;
  /* SL 2026-10-07: kaart kan een variant meegeven (data-variant-id); die staat dan vooraf geselecteerd. */
  var preferredVariantId = null;

  function openModal() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 50);
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetModal();
  }

  function resetModal() {
    if (optionsEl)  optionsEl.innerHTML  = '';
    if (feedback)   feedback.textContent  = '';
    if (feedback)   feedback.className    = 'sl-qa__feedback';
    if (atcBtn)     atcBtn.disabled       = true;
    if (atcLabel)   atcLabel.textContent  = window.slQaI18n ? window.slQaI18n.addToCart : 'In winkelwagen';
    currentProduct  = null;
    selectedVariant = null;
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    var parts = amount.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + parts.join(',');
  }

  function fetchProduct(handle, callback) {
    var url = '/products/' + handle + '.js';
    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) { callback(null, data); })
      .catch(function (err) { callback(err, null); });
  }

  function renderModal(product) {
    currentProduct = product;

    var img = product.featured_image || (product.images && product.images[0]) || '';
    if (imgEl) {
      if (img) {
        imgEl.src = img.indexOf('?') > -1 ? img : img + '?width=480';
        imgEl.alt = product.title;
        imgEl.style.display = '';
      } else {
        imgEl.style.display = 'none';
      }
    }

    if (vendorEl) {
      vendorEl.textContent = product.vendor || '';
      vendorEl.style.display = product.vendor ? '' : 'none';
    }

    if (titleEl) titleEl.textContent = product.title;

    if (viewLink) viewLink.href = '/products/' + product.handle;

    renderOptions(product);
  }

  /* SL 2026-10-05: alleen bestaande combinaties kiesbaar. Na elke klik worden de keuzegroepen
     opnieuw berekend: ongeldige knoppen verborgen, ongeldige keuze automatisch naar een geldige
     waarde, en een groep met maar één mogelijke waarde wordt verborgen. Zo komen getoonde prijs
     en toegevoegde variant altijd overeen. */
  function renderOptions(product) {
    if (!optionsEl) return;
    optionsEl.innerHTML = '';

    if (product.variants.length === 1) {
      setVariant(product.variants[0]);
      return;
    }

    product.options.forEach(function (optName, optIndex) {
      var group = document.createElement('div');
      group.className = 'sl-qa__option-group';

      var lbl = document.createElement('p');
      lbl.className = 'sl-qa__option-label';
      lbl.textContent = (typeof optName === 'object' && optName !== null) ? (optName.name || optName) : optName;
      group.appendChild(lbl);

      var pillsWrap = document.createElement('div');
      pillsWrap.className = 'sl-qa__pills';

      var seen = [];
      product.variants.forEach(function (v) {
        var val = v['option' + (optIndex + 1)];
        if (val != null && seen.indexOf(val) === -1) seen.push(val);
      });

      seen.forEach(function (val) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'sl-qa__pill';
        pill.textContent = val;
        pill.dataset.optionIndex = optIndex;
        pill.dataset.optionValue = val;

        pill.addEventListener('click', function () {
          pillsWrap.querySelectorAll('.sl-qa__pill').forEach(function (p) {
            p.classList.remove('is-selected');
          });
          pill.classList.add('is-selected');
          refreshOptions(product);
        });

        pillsWrap.appendChild(pill);
      });

      group.appendChild(pillsWrap);
      optionsEl.appendChild(group);
    });

    var preferred = preferredVariantId ? product.variants.find(function (v) { return String(v.id) === preferredVariantId && v.available; }) : null;
    var firstAvail = preferred || product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var groups = optionsEl.querySelectorAll('.sl-qa__option-group');
    product.options.forEach(function (_, i) {
      var val = firstAvail['option' + (i + 1)];
      var pill = groups[i] && groups[i].querySelector('[data-option-value="' + CSS.escape(val) + '"]');
      if (pill) pill.classList.add('is-selected');
    });
    refreshOptions(product);
  }

  function refreshOptions(product) {
    var groups = optionsEl.querySelectorAll('.sl-qa__option-group');
    var selected = [];

    groups.forEach(function (g, i) {
      var matching = product.variants.filter(function (v) {
        for (var k = 0; k < i; k++) {
          if (selected[k] != null && v['option' + (k + 1)] !== selected[k]) return false;
        }
        return true;
      });

      var valid = [];
      matching.forEach(function (v) {
        var val = v['option' + (i + 1)];
        if (val != null && valid.indexOf(val) === -1) valid.push(val);
      });

      var current = g.querySelector('.sl-qa__pill.is-selected');

      g.querySelectorAll('.sl-qa__pill').forEach(function (p) {
        var val = p.dataset.optionValue;
        var isValid = valid.indexOf(val) !== -1;
        p.hidden = !isValid;
        p.style.display = isValid ? '' : 'none';
        var hasAvail = matching.some(function (v) {
          return v['option' + (i + 1)] === val && v.available;
        });
        p.classList.toggle('is-unavailable', isValid && !hasAvail);
      });

      if (!current || valid.indexOf(current.dataset.optionValue) === -1) {
        if (current) current.classList.remove('is-selected');
        var pick = valid.find(function (val) {
          return matching.some(function (v) { return v['option' + (i + 1)] === val && v.available; });
        }) || valid[0];
        current = pick != null ? g.querySelector('[data-option-value="' + CSS.escape(pick) + '"]') : null;
        if (current) current.classList.add('is-selected');
      }

      selected.push(current ? current.dataset.optionValue : null);

      var single = valid.length <= 1;
      g.hidden = single;
      g.style.display = single ? 'none' : '';
    });

    var match = product.variants.find(function (v) {
      return product.options.every(function (_, i) {
        return v['option' + (i + 1)] === selected[i];
      });
    });

    if (match) {
      setVariant(match);
    } else {
      selectedVariant = null;
      if (atcBtn) atcBtn.disabled = true;
    }
  }

  function setVariant(variant) {
    selectedVariant = variant;

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html  = '<span class="sl-qa__price-sale">' + formatMoney(variant.price) + '</span>';
        html += '<span class="sl-qa__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
      } else {
        html = '<span>' + formatMoney(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
    }

    if (imgEl && variant.featured_image && variant.featured_image.src) {
      var src = variant.featured_image.src;
      imgEl.src = src.indexOf('?') > -1 ? src : src + '?width=480';
    }

    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      if (atcLabel) {
        atcLabel.textContent = variant.available
          ? (window.slQaI18n ? window.slQaI18n.addToCart  : 'In winkelwagen')
          : (window.slQaI18n ? window.slQaI18n.soldOut    : 'Uitverkocht');
      }
    }

    if (feedback) feedback.textContent = '';
  }

  function addToCart(variantId) {
    if (!variantId) return;

    atcBtn.disabled = true;
    atcBtn.classList.add('is-loading');
    if (feedback) { feedback.textContent = ''; feedback.className = 'sl-qa__feedback'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      })
      .then(function (addedItem) {
        atcBtn.classList.remove('is-loading');
        atcBtn.classList.add('is-success');
        if (atcLabel) atcLabel.textContent = window.slQaI18n ? window.slQaI18n.added : 'Toegevoegd ✓';
        if (feedback) {
          feedback.textContent = window.slQaI18n ? window.slQaI18n.addedMsg : 'Product toegevoegd aan winkelwagen.';
          feedback.className = 'sl-qa__feedback sl-qa__feedback--ok';
        }

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .sl-cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            if (window.SLCartModal && addedItem) {
              window.SLCartModal.show(addedItem);
            }

            closeModal();
          })
          .catch(function () {});

        setTimeout(function () {
          atcBtn.classList.remove('is-success');
          if (selectedVariant && selectedVariant.available && atcLabel) {
            atcLabel.textContent = window.slQaI18n ? window.slQaI18n.addToCart : 'In winkelwagen';
          }
          atcBtn.disabled = !(selectedVariant && selectedVariant.available);
        }, 2200);
      })
      .catch(function (err) {
        atcBtn.classList.remove('is-loading');
        atcBtn.disabled = false;
        if (feedback) {
          feedback.textContent = err.message || 'Er is een fout opgetreden.';
          feedback.className = 'sl-qa__feedback sl-qa__feedback--err';
        }
      });
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      if (selectedVariant) addToCart(selectedVariant.id);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sl-quick-add]');
    if (!btn) return;

    var handle = btn.dataset.productHandle;
    if (!handle) return;

    resetModal();
    preferredVariantId = btn.dataset.variantId ? String(btn.dataset.variantId) : null;
    if (titleEl)  titleEl.textContent  = '…';
    if (priceEl)  priceEl.textContent  = '';
    if (vendorEl) vendorEl.textContent  = '';
    if (imgEl) {
      imgEl.src = '';
      imgEl.style.display = '';
    }
    openModal();

    fetchProduct(handle, function (err, product) {
      if (err || !product) {
        if (titleEl) titleEl.textContent = 'Fout bij laden.';
        return;
      }
      renderModal(product);
    });
  });

  window.slQaI18n = window.slQaI18n || {
    addToCart : 'In winkelwagen',
    soldOut   : 'Uitverkocht',
    added     : 'Toegevoegd ✓',
    addedMsg  : 'Product toegevoegd aan winkelwagen.'
  };

})();
